import { Node } from 'tiptap';

export default class Labels extends Node {
  // eslint-disable-next-line class-methods-use-this
  get name() {
    return 'labels';
  }

  // eslint-disable-next-line class-methods-use-this
  get schema() {
    return {
      inline: true,
      attrs: {
        class: {
          default: null,
        },
      },
      selectable: false,
      group: 'inline',
      content: 'text*',
      parseDOM: [
        {
          getAttrs: dom => ({
            class: dom.getAttribute('class'),
          }),
        },
      ],
      toDOM: node => [
        'label',
        {
          class: `flex ${node.attrs.class}`,
        },
        0,
      ],
    };
  }

  // eslint-disable-next-line class-methods-use-this
  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state;
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
      const node = type.create(attrs);
      const transaction = state.tr.insert(position, node);
      dispatch(transaction);
    };
  }

  // eslint-disable-next-line class-methods-use-this
  get view() {
    return {
      props: ['node', 'updateAttrs', 'view', 'options'],
      computed: {
        src: {
          get() {
            return this.node.attrs.src;
          },
          set(src) {
            this.updateAttrs({
              src,
            });
          },
        },
      },
      template: `
       <span class="flex input-element-label" v-if="view.editable" ref="content" contenteditable="true" />
      `,
    };
  }
}



// WEBPACK FOOTER //
// ./src/includes/labels.js